module.exports = __webpack_public_path__ + "img/lampOn.1cf8e604.svg";